import { Link } from 'react-router-dom'
import { Card, CardBody } from '../components/ui/Card'
import { Logo } from '../components/Logo'
import { useTheme } from '../lib/theme'
import { Seo } from '../components/Seo'

export const seoTitle = 'Privacy Policy'
export const seoDescription =
  'How RemindLoop collects, uses and protects personal information, including customer contact details used to send invoice reminders.'

export default function Privacy() {
  const { theme } = useTheme()
  return (
    <div className="mx-auto max-w-2xl px-4 py-10">
      <Seo title={seoTitle} description={seoDescription} path="/privacy" />
      <div className="mb-6 flex justify-center">
        <Logo size={34} reversed={theme === 'dark'} />
      </div>
      <Card>
        <CardBody className="space-y-4">
          <h1 className="text-h1 text-foreground">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground">
            Placeholder — this page stands in for the real Privacy Policy, which has not been
            drafted yet.
          </p>
          <p className="text-sm text-muted-foreground">
            RemindLoop stores organisation and client contact details (including client phone
            numbers) in order to send reminders on an organisation&rsquo;s behalf. A full policy
            covering data retention, third parties, and client opt-out rights will replace this
            text before general availability.
          </p>
          <p className="text-sm text-muted-foreground">
            Under South Africa's POPIA, the organisation that uploads or connects its customers'
            personal information to RemindLoop is the <strong>responsible party</strong> for that
            information; RemindLoop acts only as its <strong>operator</strong>, processing it
            solely to provide the reminder service. See our{' '}
            <Link to="/operator-agreement" className="text-brand-700 underline underline-offset-2 hover:text-brand-800">
              Operator Agreement
            </Link>{' '}
            for details — this is a placeholder pending a fully drafted policy and has not been
            reviewed by an attorney.
          </p>
          {/* NOTE FOR THE OWNER'S LAWYER: this "Analytics cookies" section is draft
              wording describing Google Analytics (consent-gated, POPIA). Please
              review it with the rest of the policy. */}
          <h2 id="analytics-cookies" className="text-h3 text-foreground">
            Analytics cookies
          </h2>
          <p className="text-sm text-muted-foreground">
            With your permission we use Google Analytics to see which pages are visited and which
            buttons are used, so we can improve the site and the app. It records page views and
            actions such as signing up or importing a file. It does not record your name, email
            address, phone number, organisation name or any customer or invoice details. It only
            runs if you press Accept on the cookie notice; if you press No thanks, nothing is loaded.
            It is never used on the pages your customers see. You can change your choice at any time
            with the Cookie settings link at the bottom of the page.
          </p>
          <Link to="/" className="inline-block text-sm font-medium text-brand-700 hover:underline">
            ← Back to home
          </Link>
        </CardBody>
      </Card>
    </div>
  )
}
